/* eslint-disable no-console */
import {
  isValid,
  isEqual,
  isBefore,
  isAfter,
  isWithinInterval,
  isSameDay,
  isSameMinute,
  getMonth,
  getYear,
  getHours,
  getMinutes,
} from "date-fns";
import { DateVariant } from "src/requests/templates/types";
import { DateType, Tuple } from "../globalTypes";

export const isBeforeOrSame = (
  date: string | null,
  dateToCompare: string | null
): boolean => {
  if (!date || !dateToCompare) return false;

  const formatedDate = new Date(date);
  const formatedToCompare = new Date(dateToCompare);

  if (isEqual(formatedDate, formatedToCompare)) return true;

  return isBefore(formatedDate, formatedToCompare);
};

export const isAfterOrSame = (date: string, dateToCompare: string): boolean => {
  if (!date || !dateToCompare) return false;

  const formatedDate = new Date(date);
  const formatedToCompare = new Date(dateToCompare);

  if (isEqual(formatedDate, formatedToCompare)) return true;

  return isAfter(formatedDate, formatedToCompare);
};

export const isDateInRange = (
  range: Tuple<DateType>,
  date: DateType
): boolean => {
  const [from, to] = range;

  if (from === null && to === null) return true;
  if (date === null) return false;

  if (from === null) return isBeforeOrSame(date, to);
  if (to === null) return isAfterOrSame(date, from);

  return isWithinInterval(new Date(date), {
    start: new Date(from),
    end: new Date(to),
  });
};

export const isDateEqual = <T extends DateVariant | undefined = "DateTime">(
  dateStringA: DateType | number,
  dateStringB: DateType | number,
  variant: T
) => {
  if (!dateStringA || !dateStringB) return false;

  const dateA = new Date(dateStringA);
  const dateB = new Date(dateStringB);

  switch (variant) {
    case "Time":
      return (
        getHours(dateA) === getHours(dateB) &&
        getMinutes(dateA) === getMinutes(dateB)
      );
    case "Date":
      return isSameDay(dateA, dateB);
    case "DateTime":
      return isSameMinute(dateA, dateB) && isSameDay(dateA, dateB);
    case "Month":
      return getMonth(dateA) === getMonth(dateB);
    case "Year":
      return getYear(dateA) === getYear(dateB);
    default:
      return false;
  }
};
